import * as _types from "../_constants/types";
import ws from "../_constants/webservices";

export const search = (order_no, email, store) => dispatch => {
    dispatch({ type: _types.SEARCH_FETCHING });

    var url = `/public/orders/search`;

    var data = { name: order_no, email: email, store: store };

    ws.shopify
        .post(url, data)
        .then(({ json, response }) => {
            dispatch({
                type: _types.SEARCH_RESULT_LOAD,
                results: json
            });
            dispatch({
                type: _types.SEARCH_FETCHING_COMPLETED
            });
        })
        .catch(({ err, response }) => {
            dispatch({
                type: _types.SEARCH_FETCHING_FAILED,
                err: "search failed"
            });
        });
};

export const sendOrdersSummaryEmail = (email, store) => dispatch => {
    dispatch({ type: _types.ORDERS_SUMMARY_EMAIL_FETCHING });

    var url = `/public/orders/send-orders-summary-email`;

    var data = { email: email, store: store };

    ws.shopify
        .post(url, data)
        .then(({ json, response }) => {
            dispatch({
                type: _types.ORDERS_SUMMARY_EMAIL_FETCHING_COMPLETED
            });
        })
        .catch((err, response) => {
            dispatch({
                type: _types.ORDERS_SUMMARY_EMAIL_FETCHING_FAILED,
                err
            });
        });
};

export const updateSearchMessage = message => dispatch => {
    dispatch({
        type: _types.SEARCH_MESSAGE_LOAD,
        results: message
    });
};

export const resetSearchMessage = () => dispatch => {
    dispatch({
        type: _types.SEARCH_MESSAGE_RESET
    });
};

export const resetSearchResult = () => dispatch => {
    dispatch({
        type: _types.SEARCH_RESULT_RESET
    });
};



// WEBPACK FOOTER //
// ./src/_actions/search.js